import { Row, Col } from "antd";

const CustomField = ({ field, renderField, handleRulesOnValueChange }: any) => {
  return (
    <div key={field.id} className="supplementalFileContainer__body">
      <Row>
        {/* section's title and mandatory field msg */}
        {field.inputType !== "ACTN-SECTION" && (
          <Col span={7} className="supplementalFileContainer__body__heading">
            <div className="f14 w400">
              <span>{field.title}</span>
              <span className="supplementalFileContainer__body__required">{field.isRequired && "*"}</span>
              <br/>
              <span className="f12 w400 italic">{field?.subTitle}</span>
            </div>
          </Col>
        )}

        {/* rendering fields here */}
        <Col span={field.inputType !== "ACTN-SECTION" ? 9 : 24} offset={field.inputType !== "ACTN-SECTION" ? 3 : 0}  className="supplementalFileContainer__body__fields">
          {renderField(field, handleRulesOnValueChange)}
        </Col>
      </Row>
      {field.isBorder && <div className="supplementalFileContainer__body__fields__divider"></div>}
    </div>
  );
};

export default CustomField;
